export const MAX_NUMBER_OF_ARRANGEMENTS = 20;
